import { useTranslation } from "react-i18next";
import "../../css/ShoppingCart/ShoppingCart.css";
import { useEffect, useState } from "react";
import { shoppingCartRequest } from "./ShoppingCartRequest";
import { useNavigate } from "react-router-dom";
import ShoppingCartLoading from "./ShoppingCartLoading";
import { checkoutRequest } from "./CheckoutRequest";
import SuccessfulPurchase from "./SuccessfulPurchase";
import UnsuccessfulPurchase from "./UnsuccessfulPurchase";
import PurchaseError from "./PurchaseError";
function ShoppingCart({ theme }) {
  const { t } = useTranslation();

  const [data, setData] = useState([]);

  const [loadingStatus, setLoadingStatus] = useState(false);

  useEffect(() => {
    shoppingCartRequest(setData, setLoadingStatus);
  }, []);

  const navigate = useNavigate();

  const [checkoutRequestStatus, setCheckoutRequestStatus] = useState(false);

  const [checkoutStatus, setCheckoutStatus] = useState();

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>{t("Shopping Cart")}</div>
      <div className="contentDiv padding12 gap12">
        {data.length > 0 ? (
          loadingStatus ? (
            <ShoppingCartLoading theme={theme}></ShoppingCartLoading>
          ) : (
            <>
              <>
                <div className="shoppingCartStatisticsDiv">
                  <div>
                    {t("Tatal Quantity") +
                      ": " +
                      data[0]?.statistics[0]?.total_quantity}
                  </div>
                  <div>
                    {t("Tatal Price") +
                      ": " +
                      data[0]?.statistics[0]?.total_price}
                  </div>
                </div>

                {data.map((product, index) => {
                  const images = product.images || [];
                  return (
                    <div
                      className="productPreviewDiv"
                      key={index}
                      onClick={() => {
                        navigate("/p/" + product.link);
                      }}
                    >
                      <div className="productPreviewUserDiv">
                        {product.user[0].profile_image_url !== null ? (
                          <img src={product.user[0].profile_image_url}></img>
                        ) : (
                          <div className="profileImageDivInProductDiv"></div>
                        )}

                        <div>{product.user[0].username}</div>

                        {product.user[0].tick && (
                          <div className="tickDivInProductDiv">
                            <img src="/icons/green_tick.png"></img>
                          </div>
                        )}
                      </div>

                      <div className="productDataDiv">
                        <div className="productImageSlider">
                          {images.length > 0 ? (
                            images.map((image, index) => (
                              <img
                                key={index}
                                src={image}
                                alt={`${product.name} ${index + 1}`}
                                className="productImage"
                                loading="lazy"
                                decoding="async"
                              />
                            ))
                          ) : (
                            <div className="productNoImage">
                              {t("No Image")}
                            </div>
                          )}
                        </div>
                        <div className="productInfoDivInProductPreview">
                          <div>
                            {product.name?.length > 20
                              ? product.name.slice(0, 20) + "..."
                              : product.name}
                          </div>

                          <span>{product.category}</span>

                          <div className="f">
                            {Number(product.price).toLocaleString()} t
                          </div>

                          <div>
                            {t("Quantity") +
                              " " +
                              product.quantity_in_shopping_cart}{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>

              <button
                className={`submitButton ${theme}`}
                onClick={() => {
                  checkoutRequest(setCheckoutRequestStatus, setCheckoutStatus);
                }}
              >
                {checkoutRequestStatus ? (
                  <img
                    src="/icons/loading.png"
                    className={`icon rotate ${theme}`}
                  ></img>
                ) : (
                  t("Checkout")
                )}
              </button>
            </>
          )
        ) : (
          <div className="emptyDiv">
            <img src="/images/empty512.png"></img>
            <div className="emptyTitleDiv">{t("Empty")}</div>
          </div>
        )}

        {checkoutStatus == "ok" && (
          <SuccessfulPurchase
            theme={theme}
            setCheckoutStatus={setCheckoutStatus}
            setData={setData}
          ></SuccessfulPurchase>
        )}

        {checkoutStatus == "insufficient_balance" && (
          <UnsuccessfulPurchase
            theme={theme}
            setCheckoutStatus={setCheckoutStatus}
          ></UnsuccessfulPurchase>
        )}

        {checkoutStatus == "error" && (
          <PurchaseError
            theme={theme}
            setCheckoutStatus={setCheckoutStatus}
          ></PurchaseError>
        )}
      </div>
    </div>
  );
}

export default ShoppingCart;
